import { SystemStyleObject } from "@chakra-ui/theme-tools"


const baseStyle: SystemStyleObject = {
  fontFamily: "heading",
  fontWeight: "bold",
}

const baseSizes: Record<string, SystemStyleObject> = {
  "4xl": {
    fontSize: '9xl',
    lineHeight: 1,
  },
  "3xl": {
    fontSize: '7xl',
    lineHeight: 1,
  },
  "2xl": {
    fontSize: '6xl',
    lineHeight: 1
  },
  xl: {
    fontSize: '4xl',
    lineHeight: 1.2
  },
  lg: {
    fontSize: '3xl',
    lineHeight: 1.2
  },
  md: {
    fontSize: 'xl',
    lineHeight: 1.2
  },
  sm: {
    fontSize: 'md',
    lineHeight: 1.2
  },
  xs: {
    fontSize: 'sm',
    lineHeight: 1.2
  },
}

const defaultProps = {
  size: "xl",
}

export const Heading = {
  baseStyle,
  sizes: baseSizes,
  defaultProps,
}